import React from 'react'

import { Box, Tooltip } from '@mui/material'

import { findCountryByCode } from 'utils/countries'

import getFlagUrl from './flagSources'

type FlagProps = {
  country?: string
}

const Flag = ({ country = '' }: FlagProps) => {
  if (!country) return null

  const url = getFlagUrl(country.toLowerCase())

  return (
    <Tooltip title={findCountryByCode(country)?.printableName ?? country.toUpperCase()}>
      <Box sx={{ display: 'inline-block', width: '16px', margin: '2px', '& img': { width: '100%' } }}>
        {url ? <img alt={country.toUpperCase()} src={url} /> : country.toUpperCase()}
      </Box>
    </Tooltip>
  )
}

export default Flag
